module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAwCAYAAABZq4foAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADsSURBVGiB7di7DcJAEEXRtzASkjsipi2aoBMKIKAQeiAhsmQPgZ17XzRa6Z4KRlf2/lpmptDlVD3ASIhlIJaBWAZiGYhlIJaBWAZiGYhlIJYhJInLYZ89Frl6hCStxOoSmdLz/ameYwhtWdacro/qOYYQkjTnVD3HELYF/sSa1SMkSclxqweVDMQyEMtALAOxDMQyEMtALAOxDPsJvhWPMQa+LENI0mWtHmMM0STdv6/qOYYQTanbj5fSQy2333Caec861PY168xueCzZDS3EMhDLQCwDsQzEMhDLQCwDsQzEMhDLEJIUvGd1+QN1iyTSOmPnzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/russia-icon.png
// module id = M87T
// module chunks = 69